import React from 'react';

export default function IconSet() {
  return (
    <svg className="dn" xmlns="http://www.w3.org/2000/svg">
      <symbol id="icon-fullpagequiz-home-townhouse" viewBox="0 0 136 136">
        <g fill="none" fillRule="evenodd">
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            d="M88.1 117.6H117V25.8h1.7l1.7-6.8h-85l1.7 6.8h1.7v37.4l-1.7 54.2z"
          />
          <g transform="translate(15 24)">
            <path
              d="M69.7 44.3h-68A1.7 1.7 0 000 46v3.4a1.7 1.7 0 001.7 1.7h1.7v42.5H68V51.1h1.7a1.7 1.7 0 001.7-1.7V46a1.7 1.7 0 00-1.7-1.7z"
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#EAEAFB"
              strokeLinecap="round"
            />
            <circle fill="#2E2EE5" cx="62.9" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="56.1" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="49.3" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="49.3" cy="64.7" r="1.7" />
            <circle fill="#2E2EE5" cx="49.3" cy="71.5" r="1.7" />
            <circle fill="#2E2EE5" cx="56.1" cy="71.5" r="1.7" />
            <circle fill="#2E2EE5" cx="42.5" cy="71.5" r="1.7" />
            <circle fill="#2E2EE5" cx="49.3" cy="78.3" r="1.7" />
            <circle fill="#2E2EE5" cx="42.5" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="35.7" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="25.5" cy="78.3" r="1.7" />
            <circle fill="#2E2EE5" cx="28.9" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="22.1" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="15.3" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="8.5" cy="51.1" r="1.7" />
            <circle fill="#2E2EE5" cx="100.3" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="93.5" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="86.7" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="79.9" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="73.1" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="66.3" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="59.5" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="52.7" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="45.9" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="39.1" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="32.3" cy="1.8" r="1.7" />
            <circle fill="#2E2EE5" cx="25.5" cy="1.8" r="1.7" />
            <path
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
              strokeLinecap="round"
              d="M13.6 93.6V63h17v30.6M40.8 63h17v17h-17zM34 12h13.6v10.2H34zm22.1 0h13.6v10.2H56.1zm22.1 0h13.6v10.2H78.2z"
            />
            <path
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
              d="M56.1 39.2v-6.8h13.6v6.8m-35.7 0v-6.8h13.6v6.8"
            />
            <path
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
              strokeLinecap="round"
              d="M78.2 32.4h13.6v10.2H78.2zm0 20.4h13.6V63H78.2zm0 20.4h13.6v10.2H78.2z"
            />
          </g>
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-pet-birds" viewBox="0 0 136 136">
        <g transform="translate(18 12)" fill="none" fillRule="evenodd">
          <path
            d="M90.1 71.4c0 8.5-15.56 22.1-32.3 22.1C18.7 93.5 0 71.4 0 49.3 0 29.803 9.155 14.304 23.375 6.197 30.382 2.2 38.621 0 47.6 0c11.9 0 22.1 7.548 22.1 18.7L64 16.9l-4 4.296-2.2 4.725L40 43.1c4 6.867 12 13.567 24 20.1 12 6.533 20.7 9.267 26.1 8.2z"
            fill="#EAEAFB"
          />
          <path
            d="M80.75 85.85l19.55 19.55h-7.95A25.951 25.951 0 0174 97.8l-5.15-5.15"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M93.5 105.4H74.472a17.769 17.769 0 01-13.491-6.205L56.1 93.5 66 92"
            fill="#EAEAFB"
          />
          <path
            d="M80.75 85.85l19.55 19.55h-7.95A25.951 25.951 0 0174 97.8l-5.15-5.15M30.6 35.7c1.7 1.7 8.71 8.736 10.2 10.2 0 0 25.5 25.5 49.3 25.5"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.5 22.1v32.3m-17-6.8s8.5 1.7 17-3.4"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
          />
          <path
            d="M90.1 71.4c0 8.5-15.56 22.1-32.3 22.1C18.7 93.5 0 71.4 0 49.3 0 29.803 9.155 14.304 23.375 6.197 30.382 2.2 38.621 0 47.6 0c11.9 0 22.1 7.548 22.1 18.7"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
          />
          <circle fill="#2E2EE5" cx="47.6" cy="18.7" r="3.4" />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            d="M59.41 24.135L39.1 44.2"
          />
          <path
            d="M59.5 54.4c6.8 0 17-8.5 17-18.7S71.4 17 64.6 17c-2.927 0-5.1 1.771-5.1 5.1"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
          />
          <path
            d="M34 37.4c-5.508 5.4-8.5 13.779-8.5 22.1 0 16.43 15.87 34 32.3 34"
            stroke="#2E2EE5"
            strokeWidth="3.5"
          />
          <path
            d="M34 52.7h0v6.8C34 71.653 46.456 85 57.8 85h6.8"
            stroke="#2E2EE5"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="0,6"
          />
          <path
            d="M93.5 105.4H74.472a17.769 17.769 0 01-13.491-6.205L56.1 93.5"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M44.2 93.5v15.3m-17-20.4v11.9m3.4 1.7c-5.1 0-10.2 0-13.6 3.4m30.6 3.4c-5.1 0-10.2 0-13.6 3.4"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-home-apartment" viewBox="0 0 136 136">
        <g transform="translate(27 17)" fill="none" fillRule="evenodd">
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            d="M0 0v6.8h3.4V102h74.8V6.8h3.4V0z"
          />
          <circle fill="#2E2EE5" cx="51" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="44.2" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="37.4" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="30.6" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="57.8" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="23.8" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="17" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="10.2" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="64.6" cy="6.8" r="1.7" />
          <circle fill="#2E2EE5" cx="71.4" cy="6.8" r="1.7" />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
            d="M28.9 59.5h6.8v10.2h-6.8zm17 0h6.8v10.2h-6.8zm-34 0h6.8v10.2h-6.8zm17-20.4h6.8v10.2h-6.8zm17 0h6.8v10.2h-6.8zm-34 0h6.8v10.2h-6.8zm17-20.4h6.8v10.2h-6.8zm17 0h6.8v10.2h-6.8zm-34 0h6.8v10.2h-6.8zm51 40.8h6.8v10.2h-6.8zm-51 20.4h6.8v10.2h-6.8zm51 0h6.8v10.2h-6.8zm0-40.8h6.8v10.2h-6.8zm0-20.4h6.8v10.2h-6.8zM32.3 79.9h17V102h-17z"
          />
          <path stroke="#2E2EE5" strokeWidth="3.5" d="M27.2 79.9h27.2" />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-time-1y" viewBox="0 0 136 136">
        <g fill="none" fillRule="evenodd">
          <g transform="translate(19 14)">
            <path
              d="M20.4 8.5H6.8C3.045 8.5 0 9.136 0 9.92v17.76c0 .784 3.045 1.42 6.8 1.42h85c3.755 0 6.8-.636 6.8-1.42V9.92c0-.784-3.045-1.42-6.8-1.42H78.2"
              fill="#EAEAFB"
            />
            <path
              d="M20.4 1.7v13.6a1.7 1.7 0 001.7 1.7h3.4a1.7 1.7 0 001.7-1.7V1.7A1.7 1.7 0 0025.5 0h-3.4a1.7 1.7 0 00-1.7 1.7z"
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
            />
            <path
              d="M20.4 8.5H6.8A6.8 6.8 0 000 15.3v85a6.8 6.8 0 006.8 6.8h85a6.8 6.8 0 006.8-6.8v-85a6.8 6.8 0 00-6.8-6.8H78.2m-6.8 0H27.2"
              stroke="#2E2EE5"
              strokeWidth="3.5"
            />
            <path
              d="M71.4 1.7v13.6a1.7 1.7 0 001.7 1.7h3.4a1.7 1.7 0 001.7-1.7V1.7A1.7 1.7 0 0076.5 0h-3.4a1.7 1.7 0 00-1.7 1.7z"
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
            />
            <path stroke="#2E2EE5" strokeWidth="3.5" d="M98.6 28.9H0" />
            <circle fill="#2E2EE5" cx="22.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="28.9" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="35.7" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="42.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="49.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="8.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="15.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="76.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="83.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="90.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="62.9" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="56.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="69.7" cy="96.9" r="1.7" />
          </g>
          <text
            fill="#2E2EE5"
            fontFamily="Helvetica"
            fontSize="26"
            letterSpacing="-.01"
          >
            <tspan x="54.28" y="87">
              1y
            </tspan>
          </text>
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-time-1y-plus" viewBox="0 0 136 136">
        <g fill="none" fillRule="evenodd">
          <g transform="translate(19 14)">
            <path
              d="M20.4 8.5H6.8C3.045 8.5 0 9.136 0 9.92v17.76c0 .784 3.045 1.42 6.8 1.42h85c3.755 0 6.8-.636 6.8-1.42V9.92c0-.784-3.045-1.42-6.8-1.42H78.2"
              fill="#EAEAFB"
            />
            <path
              d="M20.4 1.7v13.6a1.7 1.7 0 001.7 1.7h3.4a1.7 1.7 0 001.7-1.7V1.7A1.7 1.7 0 0025.5 0h-3.4a1.7 1.7 0 00-1.7 1.7z"
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
            />
            <path
              d="M20.4 8.5H6.8A6.8 6.8 0 000 15.3v85a6.8 6.8 0 006.8 6.8h85a6.8 6.8 0 006.8-6.8v-85a6.8 6.8 0 00-6.8-6.8H78.2m-6.8 0H27.2"
              stroke="#2E2EE5"
              strokeWidth="3.5"
            />
            <path
              d="M71.4 1.7v13.6a1.7 1.7 0 001.7 1.7h3.4a1.7 1.7 0 001.7-1.7V1.7A1.7 1.7 0 0076.5 0h-3.4a1.7 1.7 0 00-1.7 1.7z"
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
            />
            <path stroke="#2E2EE5" strokeWidth="3.5" d="M98.6 28.9H0" />
            <circle fill="#2E2EE5" cx="22.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="28.9" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="35.7" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="42.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="49.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="8.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="15.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="76.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="83.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="90.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="62.9" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="56.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="69.7" cy="96.9" r="1.7" />
          </g>
          <text
            fill="#2E2EE5"
            fontFamily="Helvetica"
            fontSize="26"
            letterSpacing="-.01"
          >
            <tspan x="46.693" y="87">
              1y+
            </tspan>
          </text>
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-time-3m" viewBox="0 0 136 136">
        <g fill="none" fillRule="evenodd">
          <g transform="translate(19 14)">
            <path
              d="M20.4 8.5H6.8C3.045 8.5 0 9.136 0 9.92v17.76c0 .784 3.045 1.42 6.8 1.42h85c3.755 0 6.8-.636 6.8-1.42V9.92c0-.784-3.045-1.42-6.8-1.42H78.2"
              fill="#EAEAFB"
            />
            <path
              d="M20.4 1.7v13.6a1.7 1.7 0 001.7 1.7h3.4a1.7 1.7 0 001.7-1.7V1.7A1.7 1.7 0 0025.5 0h-3.4a1.7 1.7 0 00-1.7 1.7z"
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
            />
            <path
              d="M20.4 8.5H6.8A6.8 6.8 0 000 15.3v85a6.8 6.8 0 006.8 6.8h85a6.8 6.8 0 006.8-6.8v-85a6.8 6.8 0 00-6.8-6.8H78.2m-6.8 0H27.2"
              stroke="#2E2EE5"
              strokeWidth="3.5"
            />
            <path
              d="M71.4 1.7v13.6a1.7 1.7 0 001.7 1.7h3.4a1.7 1.7 0 001.7-1.7V1.7A1.7 1.7 0 0076.5 0h-3.4a1.7 1.7 0 00-1.7 1.7z"
              stroke="#2E2EE5"
              strokeWidth="3.5"
              fill="#FFF"
            />
            <path stroke="#2E2EE5" strokeWidth="3.5" d="M98.6 28.9H0" />
            <circle fill="#2E2EE5" cx="22.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="28.9" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="35.7" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="42.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="49.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="8.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="15.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="76.5" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="83.3" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="90.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="62.9" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="56.1" cy="96.9" r="1.7" />
            <circle fill="#2E2EE5" cx="69.7" cy="96.9" r="1.7" />
          </g>
          <text
            fill="#2E2EE5"
            fontFamily="Helvetica"
            fontSize="26"
            letterSpacing="-.01"
          >
            <tspan x="49.951" y="87">
              3m
            </tspan>
          </text>
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-pet-none" viewBox="0 0 136 136">
        <g transform="translate(14 14)" fill="none" fillRule="evenodd">
          <circle
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            cx="54.4"
            cy="54.4"
            r="54.4"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
            d="M76.038 39.975l-7.213-7.213L54.4 47.187 39.975 32.762l-7.213 7.213L47.187 54.4 32.762 68.825l7.213 7.213L54.4 61.613l14.425 14.425 7.213-7.213L61.613 54.4z"
          />
          <circle fill="#2E2EE5" cx="54.4" cy="8.5" r="1.7" />
          <circle fill="#2E2EE5" cx="54.4" cy="100.3" r="1.7" />
          <circle fill="#2E2EE5" cx="100.3" cy="54.4" r="1.7" />
          <circle fill="#2E2EE5" cx="8.5" cy="54.4" r="1.7" />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 86.855 21.944)"
            cx="86.855"
            cy="21.944"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 21.943 86.856)"
            cx="21.943"
            cy="86.856"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 86.855 86.856)"
            cx="86.855"
            cy="86.856"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 21.943 21.944)"
            cx="21.943"
            cy="21.944"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.5 36.837 11.993)"
            cx="36.837"
            cy="11.993"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.5 71.968 96.808)"
            cx="71.968"
            cy="96.808"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.5 96.81 36.835)"
            cx="96.81"
            cy="36.835"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.5 11.995 71.966)"
            cx="11.995"
            cy="71.966"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.5 71.966 11.993)"
            cx="71.966"
            cy="11.993"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.5 36.839 96.806)"
            cx="36.839"
            cy="96.806"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.5 96.809 71.964)"
            cx="96.809"
            cy="71.964"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.5 11.996 36.836)"
            cx="11.996"
            cy="36.836"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-11.25 45.447 9.382)"
            cx="45.447"
            cy="9.382"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-11.25 63.356 99.419)"
            cx="63.356"
            cy="99.419"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-11.25 99.42 45.446)"
            cx="99.42"
            cy="45.446"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-11.25 9.383 63.355)"
            cx="9.383"
            cy="63.355"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-56.25 79.904 16.234)"
            cx="79.904"
            cy="16.234"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-56.25 28.905 92.566)"
            cx="28.905"
            cy="92.566"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-56.25 92.57 79.9)"
            cx="92.57"
            cy="79.899"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-56.25 16.238 28.9)"
            cx="16.238"
            cy="28.9"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-33.75 28.902 16.234)"
            cx="28.902"
            cy="16.234"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-33.75 79.906 92.566)"
            cx="79.906"
            cy="92.566"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-33.75 92.57 28.898)"
            cx="92.57"
            cy="28.898"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-33.75 16.238 79.902)"
            cx="16.238"
            cy="79.902"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-78.75 63.356 9.382)"
            cx="63.356"
            cy="9.382"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-78.75 45.447 99.417)"
            cx="45.447"
            cy="99.417"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-78.75 99.42 63.354)"
            cx="99.419"
            cy="63.354"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-78.75 9.384 45.445)"
            cx="9.384"
            cy="45.445"
            r="1.7"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-caretaker" viewBox="0 0 136 136">
        <g transform="translate(18 16)" fill="none" fillRule="evenodd">
          <circle fill="#2E2EE5" cx="15.3" cy="78.2" r="1.7" />
          <circle fill="#2E2EE5" cx="8.5" cy="78.2" r="1.7" />
          <circle fill="#2E2EE5" cx="28.9" cy="78.2" r="1.7" />
          <circle fill="#2E2EE5" cx="22.1" cy="78.2" r="1.7" />
          <circle fill="#2E2EE5" cx="42.5" cy="78.2" r="1.7" />
          <circle fill="#2E2EE5" cx="35.7" cy="78.2" r="1.7" />
          <path
            d="M25.704 61.2S0 68.2 0 78v7h53l-3-10.962 9-8.138-11.4-4c-2.4 4.45-5.267 7.15-8.6 8.1-2.079.592-6.566 1.169-9.5-1.26-1.18-.977-2.445-3.49-3.796-7.54zm31.102-30.156s.994-7.814.994-12.626C57.8 8.92 52.7 5.1 45.9 5.1c0 0-2.972-5.1-11.9-5.1-12.658 0-23.8 13.6-23.8 13.6s3.4 1.938 3.4 8.716c0 5.103 1.195 8.259 1.195 8.259L19 31.7c.667-7.89 4.667-11.79 12-11.7 7.333.09 12-1.577 14-5 3.333.419 5.333 1.452 6 3.1.667 1.648 1 5.962 1 12.944h4.806z"
            fill="#EAEAFB"
          />
          <path
            d="M55.25 30.6c-.253 0-1.477.748-2.55 1.436v-6.818c0-8.947-7.084-10.251-7.084-10.251s-4.434 4.25-14.166 4.25c-4.374 0-12.75 3.356-12.75 11.409v1.412c-1.073-.69-2.297-1.438-2.55-1.438a2.55 2.55 0 00-2.55 2.55c0 1.027.85 3.232.85 3.825 0 1.173.952 2.125 2.125 2.125H18.7v.806c0 8.364 6.045 15.302 14.001 16.72A4.44 4.44 0 0035.7 57.8a4.44 4.44 0 002.999-1.175c7.956-1.42 14.001-8.357 14.001-16.72V39.1h2.125a2.126 2.126 0 002.125-2.125c0-.593.85-2.798.85-3.825a2.55 2.55 0 00-2.55-2.55z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
          />
          <path
            d="M56.806 31.044s.994-7.814.994-12.626C57.8 8.92 52.7 5.1 45.9 5.1c0 0-2.972-5.1-11.9-5.1-12.658 0-23.8 13.6-23.8 13.6s3.4 1.938 3.4 8.716c0 5.103 1.195 8.259 1.195 8.259M25.704 61.2S0 68.2 0 78v7h47.6m-1.904-23.8s6.963 1.897 13.643 5.097"
            stroke="#2E2EE5"
            strokeWidth="3.5"
          />
          <path
            d="M45.9 54.4v10.2s-2.914 5.1-10.2 5.1-10.2-5.1-10.2-5.1V54.4"
            stroke="#2E2EE5"
            strokeWidth="3.5"
          />
          <path fill="#EAEAFB" d="M96.9 78.2v25.5H52.7V78.2L73 63.9z" />
          <circle fill="#2E2EE5" cx="43.35" cy="36.55" r="2.55" />
          <circle fill="#2E2EE5" cx="28.05" cy="36.55" r="2.55" />
          <circle fill="#2E2EE5" cx="95.2" cy="96.9" r="1.7" />
          <circle fill="#2E2EE5" cx="88.4" cy="96.9" r="1.7" />
          <circle fill="#2E2EE5" cx="61.2" cy="96.9" r="1.7" />
          <circle fill="#2E2EE5" cx="54.4" cy="96.9" r="1.7" />
          <path
            d="M53.698 76.968L74.8 62.9l21.102 14.068c1.88 1.252 4.398-.094 4.398-2.353h0c0-.945-.473-1.83-1.26-2.355L74.8 56.1 50.56 72.26a2.83 2.83 0 00-1.26 2.355h0c0 2.259 2.518 3.605 4.398 2.353z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
            d="M68 83.3h13.6v20.4H68z"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            d="M96.9 78.2v25.5H52.7V78.2"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-pet-cats" viewBox="0 0 136 136">
        <g transform="translate(16 14)" fill="none" fillRule="evenodd">
          <path
            d="M46.75 62.475c2.55-5.1 7.686-6.394 11.05-6.375 5.663.032 10.2 5.343 10.2 7.604v32.858c0 2.968 1.872 5.299 4.838 5.299 2.967 0 5.362-1.993 5.362-4.961V66.3c0-2.332 1.846-4.25 4.179-4.25 2.332 0 4.321 1.918 4.321 4.25v30.6c0 2.968 2.132 5.1 5.1 5.1 2.968 0 5.1-2.132 5.1-5.1V40.385C87.22 42.538 82.379 43.077 82.379 42c0-1-3.525-.666-7.379-3.426-2.365-1.694-5.62-6.638-6-7.622-.667-1.726-9.333 3.257-26 14.948l3.75 16.575z"
            fill="#EAEAFB"
          />
          <path
            d="M95.2 15.3c-2.543-1.272-5.532-1.7-8.5-1.7s-6.168.428-8.5 1.7l-8.54-8.5v21.199c0 8.267 7.712 14.506 17.04 14.506s17-6.239 17-14.506V6.8l-8.5 8.5z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinejoin="round"
          />
          <circle fill="#2E2EE5" cx="79.909" cy="23.808" r="3.392" />
          <circle fill="#2E2EE5" cx="93.492" cy="23.808" r="3.392" />
          <path
            d="M46.75 62.475c2.55-5.1 7.686-6.394 11.05-6.375 5.663.032 10.2 5.343 10.2 7.604v32.858c0 2.968 1.872 5.299 4.838 5.299 2.967 0 5.362-1.993 5.362-4.961V66.3c0-2.332 1.846-4.25 4.179-4.25 2.332 0 4.321 1.918 4.321 4.25v30.6c0 2.968 2.132 5.1 5.1 5.1 2.968 0 5.1-2.132 5.1-5.1V40.385"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M69.234 29.362C64.36 27.03 55.44 25.546 45.9 25.546c-18.7 0-23.8 8.48-28.9 8.48-4.663 0-8.5-3.817-8.5-8.48S12.337 17 17 17c16.11 0 21.073-6.93 22.768-12.864.423-1.697-.423-3.391-2.12-4.027-1.696-.423-3.391.423-4.027 2.12C32.137 7.95 26.75 10.2 17 10.2c-8.267 0-15.3 7.079-15.3 15.346 0 16.534 17 16.96 17 16.96v54.056c0 2.968 2.414 5.299 5.382 5.299 2.968 0 4.818-2.331 4.818-5.3V74.8c4.619 0 19.56-6.8 19.56-19.575"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle fill="#2E2EE5" cx="86.7" cy="30.6" r="1.7" />
          <path
            d="M48.45 54.4c0-7.225-2.125-17-7.65-18.7"
            stroke="#2E2EE5"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="0,6"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-pet-dogs" viewBox="0 0 136 136">
        <g transform="translate(17 17)" fill="none" fillRule="evenodd">
          <path
            d="M17 79.35V95.2a6.8 6.8 0 006.8 6.8H34s-1.137-5.698-6.8-5.698V83.3s12.373-6.757 17.078-14.025L32 66"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinejoin="round"
          />
          <path
            d="M101.62 17.177l-3.89-.981a2.829 2.829 0 000 4.003l2.422 2.397c1.685-3.26 1.467-5.42 1.467-5.42z"
            fill="#2E2EE5"
          />
          <path
            d="M73.115 101.985l8.485-.02s0-5.065-5.1-5.065l.024-33.322L68 71.037 69 97l4.115 4.985z"
            fill="#EAEAFB"
          />
          <path
            d="M73.115 101.985l8.485-.02s0-5.065-5.1-5.065l.024-33.322"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinejoin="round"
          />
          <path
            d="M87.844 8.54C83.841.526 78.311.042 75.384.042h-4.528c-4.59 0-7.61 3.236-8.945 6.78-.67 1.776-6.146 16.6-8.043 21.535-1.897 4.935-8.096 5.664-11.45 5.664H22.724c-.609 0-1.644.094-2.873.38-4.457-1.028-11.652-3.593-13.423-9.759-1.702-5.924-.061-12.69 4.879-20.099a2.923 2.923 0 00-.81-4.051 2.915 2.915 0 00-4.049.81C.496 10.228-1.229 19.19.833 26.31c1.943 6.698 6.62 11.3 10.358 14.059C9.596 42.849 8.5 46.27 8.5 51 8.5 65.161 0 76.5 0 76.5v18.7a6.8 6.8 0 006.8 6.8H17s-1.137-5.698-6.8-5.698V83.3c15.3-6.8 20.4-17 20.4-17 8.5 0 13.6 6.82 27.2 6.82v22.065a6.8 6.8 0 006.815 6.8l8.485-.02s0-5.065-5.1-5.065l.022-27.19c.25-.109 11.878-5.2 11.878-15.295V37.41c0-2.832 0-6.801 5.112-6.801C102 30.608 102 17 102 17s-11.325-2.796-14.156-8.46z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinejoin="round"
          />
          <path
            d="M65.193 15.33S62.9 19.973 62.9 25.52c0 7.089 2.892 13.581 8.5 13.581 6.33 0 8.5-5.65 8.5-11.9 0-9.187-5.1-17-5.1-17"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.204 12.396a1.688 1.688 0 010 2.39c-.662.662-2.887.495-2.887.495s-.165-2.225.495-2.886a1.691 1.691 0 012.392.001z"
            fill="#2E2EE5"
          />
          <circle fill="#2E2EE5" cx="57.8" cy="68" r="1.7" />
          <circle fill="#2E2EE5" cx="32.3" cy="61.2" r="1.7" />
          <circle fill="#2E2EE5" cx="34" cy="54.4" r="1.7" />
          <circle fill="#2E2EE5" cx="57.8" cy="61.2" r="1.7" />
          <circle fill="#2E2EE5" cx="52.7" cy="34" r="1.7" />
          <circle fill="#2E2EE5" cx="56.1" cy="39.1" r="1.7" />
          <circle fill="#2E2EE5" cx="61.2" cy="42.5" r="1.7" />
          <circle fill="#2E2EE5" cx="66.3" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="73.1" cy="47.6" r="1.7" />
          <circle fill="#2E2EE5" cx="78.2" cy="45.9" r="1.7" />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-dogpark" viewBox="0 0 136 136">
        <g transform="translate(9 9)" fill="none" fillRule="evenodd">
          <path
            d="M22.341 75.74L2.761 94.053a6.217 6.217 0 008.454 9.118l10.776-9.899L28 81.92l-5.659-6.18zm59.427-36.166l26.374-4.887a6.125 6.125 0 112.162 12.058l-19.373 2.66L85 48.002l-3.232-8.428z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinejoin="round"
          />
          <path
            d="M54.01 72.131c5.12-2.59 12.157-7.324 19.206-12.895l37.126 7.93a6.505 6.505 0 007.64-4.665h0a6.506 6.506 0 00-4.85-8.043l-28.02-6.32c.51-6.607-4.46-10.906-4.46-10.906l1.854-5.38a14.115 14.115 0 016.739-7.873l6.944-3.68a6.09 6.09 0 003.239-5.38l.65-5.629a2.723 2.723 0 00-3.088-3.007l-8.775 1.248-5.18-1.945a7.053 7.053 0 00-4.566-.136L68.88 8.412c-4.45-1.753-9.524.51-12.407 2.208-1.098.648-1.06 2.246.061 2.856l6.032 3.293a4.935 4.935 0 012.042 6.555l-.143.282a36.211 36.211 0 01-12.723 14.14L30.948 51.143a28.893 28.893 0 01-19.147 4.395h0a4.233 4.233 0 00-4.687 3.492h0a4.234 4.234 0 003.548 4.898l7.474 1.115s1.225 9.994 9.33 16.69c0 0-8.152 16.614-12.705 25.844a6.666 6.666 0 003.082 8.955l.15.072c3.223 1.565 7.067.258 8.656-2.914 2.312-4.609 5.72-11.385 9.04-17.983 13.97-9.773 20.584-16.796 17.419-25.838"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle fill="#2E2EE5" cx="113.9" cy="5.1" r="5.1" />
          <circle fill="#2E2EE5" cx="83.434" cy="13.248" r="2.666" />
          <path
            d="M39.544 59.923c3.617-1.356 9.946-6.329 13.11 7.686"
            stroke="#2E2EE5"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="0,6"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-gender-any" viewBox="0 0 136 136">
        <g transform="translate(10 24)" fill="none" fillRule="evenodd">
          <circle
            fillOpacity=".15"
            fill="#040416"
            fillRule="nonzero"
            cx="45.5"
            cy="43.5"
            r="27.5"
          />
          <path
            d="M71.5 71C86.688 71 99 58.688 99 43.5S86.688 16 71.5 16c-4.498 0-8.744 1.08-12.492 2.995-1.941.991 3.405 2.219 3.992 3.505 2.109 4.617 8 11.44 8 19.8 0 3.05 1.386 5.59 0 9.056-1.496 3.74-6.23 12.069-9 14.144-.933.7-1.748 1.252-2 1-1.443-1.443 6.655 4.5 11.5 4.5z"
            fillOpacity=".15"
            fill="#040416"
            fillRule="nonzero"
          />
          <circle fill="#040416" cx="25.5" cy="44.2" r="1.7" />
          <circle
            fill="#040416"
            transform="rotate(-45 30.977 30.977)"
            cx="30.977"
            cy="30.977"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-45 30.976 57.422)"
            cx="30.976"
            cy="57.422"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-22.5 26.925 51.358)"
            cx="26.925"
            cy="51.358"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-22.5 37.045 26.924)"
            cx="37.045"
            cy="26.924"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-67.5 26.924 37.044)"
            cx="26.924"
            cy="37.044"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-67.5 37.047 61.478)"
            cx="37.047"
            cy="61.478"
            r="1.7"
          />
          <circle fill="#040416" cx="90.1" cy="44.2" r="1.7" />
          <circle fill="#040416" cx="52.7" cy="44.2" r="1.7" />
          <circle
            fill="#040416"
            transform="rotate(-45 84.621 57.423)"
            cx="84.621"
            cy="57.423"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-45 84.622 30.978)"
            cx="84.622"
            cy="30.978"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-22.5 88.68 37.042)"
            cx="88.68"
            cy="37.042"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-22.5 54.126 51.358)"
            cx="54.126"
            cy="51.358"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-22.5 78.56 61.477)"
            cx="78.56"
            cy="61.477"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-67.5 88.68 51.355)"
            cx="88.681"
            cy="51.355"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-67.5 54.125 37.044)"
            cx="54.125"
            cy="37.044"
            r="1.7"
          />
          <circle
            fill="#040416"
            transform="rotate(-67.5 78.558 26.922)"
            cx="78.558"
            cy="26.922"
            r="1.7"
          />
          <circle fill="#040416" cx="100.3" cy="15.3" r="1.7" />
          <circle fill="#040416" cx="95.2" cy="20.4" r="1.7" />
          <circle fill="#040416" cx="20.4" cy="68" r="1.7" />
          <circle fill="#040416" cx="15.3" cy="73.1" r="1.7" />
          <path stroke="#040416" strokeWidth="3.5" d="M96.9 0h18.7v18.7" />
          <path
            stroke="#040416"
            strokeWidth="3.5"
            strokeLinecap="round"
            d="M115.6 0l-10.2 10.2"
          />
          <path
            stroke="#040416"
            strokeWidth="3.5"
            d="M0 88.4l15.3-15.3M1.7 69.7l17 17"
          />
          <path
            d="M71.4 15.3c-2.676 0-5.256.394-7.718 1.078a34.35 34.35 0 013.37 2.72c1.415-.243 2.864-.398 4.348-.398 14.06 0 25.5 11.44 25.5 25.5S85.46 69.7 71.4 69.7 45.9 58.26 45.9 44.2c0-7.09 2.914-13.508 7.6-18.134a20.235 20.235 0 00-3.357-1.377C45.413 29.837 42.5 36.676 42.5 44.2c0 15.936 12.964 28.9 28.9 28.9 15.936 0 28.9-12.964 28.9-28.9 0-15.936-12.964-28.9-28.9-28.9z"
            fill="#040416"
          />
          <path
            d="M48.549 69.3c-1.416.245-2.865.4-4.349.4-14.06 0-25.5-11.44-25.5-25.5s11.44-25.5 25.5-25.5 25.5 11.44 25.5 25.5c0 7.09-2.914 13.508-7.6 18.134 1.069.55 2.187 1.02 3.357 1.377C70.187 58.563 73.1 51.724 73.1 44.2c0-15.936-12.964-28.9-28.9-28.9-15.936 0-28.9 12.964-28.9 28.9 0 15.936 12.964 28.9 28.9 28.9 2.676 0 5.256-.394 7.718-1.078a34.119 34.119 0 01-3.37-2.722z"
            fill="#040416"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-gender-female" viewBox="0 0 136 136">
        <g transform="translate(37 18)" fill="none" fillRule="evenodd">
          <circle fill="#E54563" cx="30.6" cy="76.5" r="1.7" />
          <circle fill="#E54563" cx="30.6" cy="69.7" r="1.7" />
          <circle fill="#E54563" cx="30.6" cy="52.7" r="1.7" />
          <circle fill="#E54563" cx="30.6" cy="8.5" r="1.7" />
          <circle fill="#E54563" cx="8.5" cy="30.6" r="1.7" />
          <circle fill="#E54563" cx="52.7" cy="30.6" r="1.7" />
          <circle
            fill="#E54563"
            transform="rotate(-45 46.225 46.227)"
            cx="46.225"
            cy="46.227"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-45 14.973 14.973)"
            cx="14.973"
            cy="14.973"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-45 14.972 46.226)"
            cx="14.972"
            cy="46.226"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-45 46.226 14.974)"
            cx="46.226"
            cy="14.974"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-22.5 39.06 51.017)"
            cx="39.06"
            cy="51.017"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-22.5 22.144 10.183)"
            cx="22.144"
            cy="10.183"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-22.5 10.185 39.058)"
            cx="10.185"
            cy="39.058"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-22.5 51.02 22.142)"
            cx="51.019"
            cy="22.142"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-67.5 51.02 39.057)"
            cx="51.02"
            cy="39.057"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-67.5 10.184 22.142)"
            cx="10.184"
            cy="22.142"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-67.5 22.144 51.018)"
            cx="22.144"
            cy="51.018"
            r="1.7"
          />
          <circle
            fill="#E54563"
            transform="rotate(-67.5 39.06 10.181)"
            cx="39.06"
            cy="10.181"
            r="1.7"
          />
          <circle fill="#E54563" cx="30.6" cy="62.9" r="1.7" />
          <circle
            stroke="#E54563"
            strokeWidth="3.5"
            fillOpacity=".15"
            fill="#E54563"
            cx="30.6"
            cy="30.6"
            r="30.6"
          />
          <path
            stroke="#E54563"
            strokeWidth="3.5"
            d="M30.6 100.3V76.5M17 85h27.2"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-gender-male" viewBox="0 0 136 136">
        <g transform="translate(24 24)" fill="none" fillRule="evenodd">
          <circle
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            cx="30.6"
            cy="57.8"
            r="30.6"
          />
          <circle fill="#2E2EE5" cx="56.1" cy="32.3" r="1.7" />
          <circle fill="#2E2EE5" cx="30.6" cy="79.9" r="1.7" />
          <circle fill="#2E2EE5" cx="30.6" cy="35.7" r="1.7" />
          <circle fill="#2E2EE5" cx="8.5" cy="57.8" r="1.7" />
          <circle fill="#2E2EE5" cx="52.7" cy="57.8" r="1.7" />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 46.225 73.427)"
            cx="46.225"
            cy="73.427"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 14.973 42.173)"
            cx="14.973"
            cy="42.173"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 14.972 73.426)"
            cx="14.972"
            cy="73.426"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 46.226 42.174)"
            cx="46.226"
            cy="42.174"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.5 39.06 78.218)"
            cx="39.06"
            cy="78.218"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.5 22.145 37.383)"
            cx="22.145"
            cy="37.383"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.5 10.185 66.258)"
            cx="10.185"
            cy="66.258"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.5 51.02 49.343)"
            cx="51.02"
            cy="49.343"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.5 51.02 66.258)"
            cx="51.021"
            cy="66.258"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.5 10.184 49.343)"
            cx="10.184"
            cy="49.343"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.5 22.145 78.218)"
            cx="22.145"
            cy="78.218"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.5 39.06 37.382)"
            cx="39.06"
            cy="37.382"
            r="1.7"
          />
          <circle fill="#2E2EE5" cx="61.2" cy="27.2" r="1.7" />
          <path stroke="#2E2EE5" strokeWidth="3.5" d="M61.2 0h27.2v27.2" />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            d="M88.4 0L66.3 22.1"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-home-house" viewBox="0 0 136 136">
        <g transform="translate(14 19)" fill="none" fillRule="evenodd">
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            strokeLinecap="round"
            d="M103.7 45.9v52.7H5.1V45.9H30L54.4 22 78 45.9z"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            d="M103.7 45.9v52.7H5.1V45.9M0 0v45.9h30.6l23.8-23.8 23.8 23.8h30.6V0z"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
            strokeLinecap="round"
            d="M42.5 96.8v-39h23.8v39m10.2-39h17v20.4h-17zm-61.2 0h17v20.4h-17z"
          />
          <circle fill="#2E2EE5" cx="27.2" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="34" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="40.8" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="20.4" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="13.6" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="6.8" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="88.4" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="95.2" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="102" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="81.6" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="85" cy="68" r="1.7" />
          <circle fill="#2E2EE5" cx="91.8" cy="68" r="1.7" />
          <circle fill="#2E2EE5" cx="78.2" cy="68" r="1.7" />
          <circle fill="#2E2EE5" cx="23.8" cy="68" r="1.7" />
          <circle fill="#2E2EE5" cx="30.6" cy="68" r="1.7" />
          <circle fill="#2E2EE5" cx="17" cy="68" r="1.7" />
          <circle fill="#2E2EE5" cx="74.8" cy="88.4" r="1.7" />
          <circle fill="#2E2EE5" cx="59.5" cy="78.2" r="1.7" />
          <circle fill="#2E2EE5" cx="68" cy="88.4" r="1.7" />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-lock" viewBox="0 0 136 136">
        <g transform="translate(29 15)" fill="none" fillRule="evenodd">
          <circle
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            cx="39.1"
            cy="66.3"
            r="39.1"
          />
          <circle fill="#2E2EE5" cx="39.1" cy="35.7" r="1.7" />
          <circle fill="#2E2EE5" cx="39.1" cy="96.9" r="1.7" />
          <circle fill="#2E2EE5" cx="69.7" cy="66.3" r="1.7" />
          <circle fill="#2E2EE5" cx="8.5" cy="66.3" r="1.7" />
          <circle fill="#2E2EE5" cx="23.8" cy="39.8" r="1.7" />
          <circle fill="#2E2EE5" cx="54.4" cy="92.8" r="1.7" />
          <circle fill="#2E2EE5" cx="65.6" cy="51" r="1.7" />
          <circle fill="#2E2EE5" cx="12.6" cy="81.6" r="1.7" />
          <circle fill="#2E2EE5" cx="12.6" cy="51" r="1.7" />
          <circle fill="#2E2EE5" cx="65.6" cy="81.6" r="1.7" />
          <circle fill="#2E2EE5" cx="54.4" cy="39.8" r="1.7" />
          <circle fill="#2E2EE5" cx="23.8" cy="92.8" r="1.7" />
          <circle fill="#2E2EE5" cx="31.18" cy="36.742" r="1.7" />
          <circle fill="#2E2EE5" cx="47.02" cy="95.858" r="1.7" />
          <circle fill="#2E2EE5" cx="68.658" cy="58.38" r="1.7" />
          <circle fill="#2E2EE5" cx="9.542" cy="74.22" r="1.7" />
          <circle fill="#2E2EE5" cx="17.462" cy="44.662" r="1.7" />
          <circle fill="#2E2EE5" cx="60.738" cy="87.938" r="1.7" />
          <circle fill="#2E2EE5" cx="60.738" cy="44.662" r="1.7" />
          <circle fill="#2E2EE5" cx="17.462" cy="87.938" r="1.7" />
          <circle fill="#2E2EE5" cx="9.542" cy="58.38" r="1.7" />
          <circle fill="#2E2EE5" cx="68.658" cy="74.22" r="1.7" />
          <circle fill="#2E2EE5" cx="47.02" cy="36.742" r="1.7" />
          <circle fill="#2E2EE5" cx="31.18" cy="95.858" r="1.7" />
          <path
            d="M13.6 37.4V25.5C13.6 11.417 25.017 0 39.1 0h0c14.083 0 25.5 11.417 25.5 25.5v11.9"
            stroke="#2E2EE5"
            strokeWidth="3.5"
          />
          <path
            d="M45.9 62.9a6.8 6.8 0 00-13.6 0c0 2.51 1.375 4.678 3.4 5.857V76.5a3.4 3.4 0 003.4 3.4 3.4 3.4 0 003.4-3.4v-7.743c2.025-1.179 3.4-3.346 3.4-5.857z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-locationmarker" viewBox="0 0 136 136">
        <g transform="translate(12 13)" fill="none" fillRule="evenodd">
          <path
            d="M90.1 34c0 18.778-34 64.91-34 64.91s-34-46.132-34-64.91 15.222-34 34-34 34 15.222 34 34z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
          />
          <path
            d="M80.327 78.105a310.642 310.642 0 01-1.942 3.138C97.021 83.616 108.8 88.755 108.8 93.5c0 6.433-21.643 13.6-52.7 13.6-31.057 0-52.7-7.167-52.7-13.6 0-4.745 11.78-9.884 30.415-12.257a358.645 358.645 0 01-1.942-3.138C14.105 80.56 0 85.789 0 93.5c0 11.041 28.903 17 56.1 17 27.197 0 56.1-5.959 56.1-17 0-7.711-14.105-12.94-31.873-15.395z"
            fill="#2E2EE5"
          />
          <circle
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
            cx="56.1"
            cy="34"
            r="8.5"
          />
          <circle fill="#2E2EE5" cx="56.1" cy="8.5" r="1.7" />
          <circle fill="#2E2EE5" cx="81.6" cy="34" r="1.7" />
          <circle fill="#2E2EE5" cx="30.6" cy="34" r="1.7" />
          <circle
            fill="#2E2EE5"
            transform="rotate(-30.001 43.349 11.916)"
            cx="43.349"
            cy="11.916"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-30.001 78.18 21.25)"
            cx="78.181"
            cy="21.249"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-59.999 34.016 21.25)"
            cx="34.016"
            cy="21.251"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-59.999 68.85 11.919)"
            cx="68.85"
            cy="11.919"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-14.999 49.498 9.37)"
            cx="49.498"
            cy="9.369"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-14.999 80.728 27.401)"
            cx="80.728"
            cy="27.401"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-14.999 31.466 40.599)"
            cx="31.466"
            cy="40.599"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 38.067 15.969)"
            cx="38.067"
            cy="15.969"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-45 74.13 15.968)"
            cx="74.13"
            cy="15.968"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-75.001 31.467 27.4)"
            cx="31.467"
            cy="27.401"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-75.001 80.728 40.601)"
            cx="80.728"
            cy="40.601"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-75.001 62.698 9.37)"
            cx="62.698"
            cy="9.371"
            r="1.7"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-mailbox" viewBox="0 0 136 136">
        <g transform="translate(9 23)" fill="none" fillRule="evenodd">
          <circle fill="#2E2EE5" cx="108.8" cy="69.7" r="1.7" />
          <circle fill="#2E2EE5" cx="102" cy="69.7" r="1.7" />
          <circle fill="#2E2EE5" cx="95.2" cy="69.7" r="1.7" />
          <circle fill="#2E2EE5" cx="88.4" cy="69.7" r="1.7" />
          <circle fill="#2E2EE5" cx="81.6" cy="69.7" r="1.7" />
          <circle fill="#2E2EE5" cx="74.8" cy="69.7" r="1.7" />
          <circle fill="#2E2EE5" cx="68" cy="69.7" r="1.7" />
          <circle fill="#2E2EE5" cx="61.2" cy="69.7" r="1.7" />
          <circle fill="#2E2EE5" cx="54.4" cy="69.7" r="1.7" />
          <path
            d="M69.7 5.1h-34c-11.266 0-20.4 9.134-20.4 20.4v44.2H3.4A3.4 3.4 0 000 73.1a3.4 3.4 0 003.4 3.4h110.5a3.4 3.4 0 003.4-3.4 3.4 3.4 0 00-3.4-3.4V25.5c0-11.266-9.134-20.4-20.4-20.4"
            fill="#EAEAFB"
          />
          <path
            d="M69.7 5.1h-34c-11.266 0-20.4 9.134-20.4 20.4v44.2H3.4A3.4 3.4 0 000 73.1a3.4 3.4 0 003.4 3.4h110.5a3.4 3.4 0 003.4-3.4 3.4 3.4 0 00-3.4-3.4V25.5c0-11.266-9.134-20.4-20.4-20.4"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinejoin="round"
          />
          <path
            d="M34 5.1h0c11.266 0 20.4 9.134 20.4 20.4v44.2"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinejoin="round"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M54.4 69.7H15.3M74.8 8.5h13.6V0H74.8v27.2"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M74.8 8.5h13.6V0H74.8v27.2"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinejoin="round"
            d="M73.1 98.6V76.5M62.9 98.6V76.5"
          />
          <circle fill="#2E2EE5" cx="74.8" cy="27.2" r="3.4" />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
            strokeLinejoin="round"
            d="M25.5 69.7V27.2h28.9v42.5z"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinejoin="round"
            d="M25.5 69.7V27.2h28.9m-28.521 5.792L54.4 47.6"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-pram" viewBox="0 0 136 136">
        <g transform="translate(24 19)" fill="none" fillRule="evenodd">
          <circle
            stroke="#2E2EE5"
            strokeWidth="3.5"
            cx="25.5"
            cy="11.9"
            r="8.5"
          />
          <path
            d="M13.6 39.1c0-6.572 5.328-11.9 11.9-11.9s11.9 5.328 11.9 11.9"
            stroke="#2E2EE5"
            strokeWidth="3.5"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            d="M57.8 0l15.927 9.076L84.44 25.378 85.566 39.1H49.3z"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            d="M62.9 90.1L30.6 62.9"
          />
          <path
            d="M85 39.1H3.4A3.4 3.4 0 000 42.5a3.4 3.4 0 003.4 3.4h.716l1.873 8.901a10.2 10.2 0 009.983 8.099H72.43c4.823 0 8.988-3.378 9.98-8.099l1.874-8.901H85a3.4 3.4 0 003.4-3.4 3.4 3.4 0 00-3.4-3.4z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
          />
          <circle fill="#2E2EE5" cx="78.2" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="71.4" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="30.6" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="37.4" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="44.2" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="51" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="57.8" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="23.8" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="64.6" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="17" cy="45.9" r="1.7" />
          <circle fill="#2E2EE5" cx="10.2" cy="45.9" r="1.7" />
          <path
            stroke="#2E2EE5"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="0,6"
            d="M69.7 13.6L57.8 34m22.1-6.8l-15.3 3.4"
          />
          <circle
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            cx="62.9"
            cy="90.1"
            r="8.5"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            d="M27.2 90.1l32.3-27.2"
          />
          <circle
            stroke="#2E2EE5"
            strokeWidth="3.5"
            strokeLinecap="round"
            cx="27.2"
            cy="90.1"
            r="8.5"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-questionmark" viewBox="0 0 136 136">
        <g transform="translate(14 14)" fill="none" fillRule="evenodd">
          <path
            d="M54.4 0C24.356 0 0 22.073 0 49.3c0 15.808 8.221 29.869 20.988 38.89C17.746 101.534 8.5 104.594 8.5 108.8c11.166 0 23.064-7.334 29.917-12.367A59.533 59.533 0 0054.4 98.6c30.044 0 54.4-22.073 54.4-49.3C108.8 22.073 84.444 0 54.4 0z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-89.885 54.492 8.5)"
            cx="54.492"
            cy="8.5"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-89.885 54.31 90.102)"
            cx="54.31"
            cy="90.102"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-89.885 100.302 54.492)"
            cx="100.302"
            cy="54.492"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-89.885 8.5 54.31)"
            cx="8.5"
            cy="54.31"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-44.887 86.92 22.008)"
            cx="86.92"
            cy="22.008"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-44.887 21.879 76.591)"
            cx="21.879"
            cy="76.591"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-44.887 86.79 76.72)"
            cx="86.791"
            cy="76.72"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-44.887 22.008 21.879)"
            cx="22.008"
            cy="21.879"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.384 36.916 11.96)"
            cx="36.916"
            cy="11.961"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.384 71.873 86.64)"
            cx="71.873"
            cy="86.641"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.384 96.834 36.922)"
            cx="96.834"
            cy="36.922"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.387 72.048 12.03)"
            cx="72.048"
            cy="12.03"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.387 98.156 62.527)"
            cx="98.156"
            cy="62.527"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-67.387 12.028 36.75)"
            cx="12.028"
            cy="36.75"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-11.134 45.535 9.367)"
            cx="45.535"
            cy="9.367"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-11.134 63.264 89.243)"
            cx="63.264"
            cy="89.243"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-11.134 99.437 45.54)"
            cx="99.437"
            cy="45.541"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-56.138 79.975 16.282)"
            cx="79.975"
            cy="16.282"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-56.138 93.126 70.23)"
            cx="93.126"
            cy="70.231"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-22.613 10.64 62.525)"
            cx="10.64"
            cy="62.525"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-33.862 15.673 70.239)"
            cx="15.673"
            cy="70.239"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-56.138 16.287 28.822)"
            cx="16.287"
            cy="28.822"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-33.634 28.976 16.187)"
            cx="28.976"
            cy="16.187"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-33.634 79.826 82.419)"
            cx="79.826"
            cy="82.419"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-33.634 92.616 28.978)"
            cx="92.616"
            cy="28.978"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-78.638 63.44 9.399)"
            cx="63.441"
            cy="9.399"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-78.638 45.355 89.196)"
            cx="45.355"
            cy="89.196"
            r="1.7"
          />
          <circle
            fill="#2E2EE5"
            transform="rotate(-78.638 9.4 45.354)"
            cx="9.399"
            cy="45.354"
            r="1.7"
          />
          <path
            d="M54.592 25.184c9.552 0 15.933 5.508 15.933 13.212 0 5.335-2.65 9.065-7.392 11.888-4.568 2.685-5.857 4.463-5.857 7.914v1.987h-8.088l-.036-2.371c-.314-5.23 1.709-8.368 6.52-11.191 4.323-2.615 5.786-4.463 5.786-7.914 0-3.626-2.929-6.24-7.322-6.24-4.498 0-7.391 2.72-7.67 6.973h-8.192c.28-8.262 5.963-14.258 16.318-14.258zm-6.764 46.088c0-3.38 2.302-5.577 5.787-5.577 3.556 0 5.786 2.196 5.786 5.578 0 3.347-2.23 5.543-5.786 5.543-3.485 0-5.787-2.196-5.787-5.544z"
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#FFF"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-zipcode" viewBox="0 0 136 136">
        <g transform="translate(14 14)" fill="none" fillRule="evenodd">
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            fill="#EAEAFB"
            d="M103.7 42.7v64.4H5.1V42.7L54 11.962z"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            d="M103.7 42.7v64.4H5.1V42.7"
          />
          <path
            stroke="#2E2EE5"
            strokeWidth="3.5"
            d="M0 45.9l54.4-34 54.4 34V34L54.4 0 0 34z"
          />
          <circle fill="#2E2EE5" cx="102" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="95.2" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="88.4" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="81.6" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="74.8" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="68" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="61.2" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="54.4" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="47.6" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="27.2" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="34" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="40.8" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="20.4" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="13.6" cy="98.6" r="1.7" />
          <circle fill="#2E2EE5" cx="6.8" cy="98.6" r="1.7" />
          <path
            fill="#2E2EE5"
            d="M25.323 72.763l11.239-14.875v-.316H25.505v-4.898h18.362v3.868L32.628 71.417v.316h11.587v4.898H25.323zm25.59 3.867V52.676h6.093V76.63z"
          />
          <path
            d="M74.843 52.675c5.145 0 8.632 3.354 8.632 8.5 0 5.096-3.668 8.433-8.998 8.433h-4.034v7.023H64.35V52.675h10.493zM70.445 65.01H73.2c2.59 0 4.118-1.328 4.118-3.819 0-2.522-1.512-3.835-4.084-3.835h-2.79v7.654z"
            fill="#2E2EE5"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="icon-fullpagequiz-cake" viewBox="0 0 136 136">
        <path
          d="M21.9 69.8h91.8c2.836 0 5.1 2.264 5.1 5.1V80c0 .87-.724 1.979-2.543 3.008l-.857.492v25.4c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7h6.461c-.398 2.55-1.348 4.316-2.477 5.313-1.354 1.182-2.53 1.467-2.61 1.487H18.826c-.08-.02-1.255-.305-2.61-1.487-1.128-.997-2.078-2.763-2.476-5.313H20.2c.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7V83.5l-.857-.492C17.523 81.978 16.8 80.87 16.8 80v-5.1c0-2.836 2.264-5.1 5.1-5.1z"
          fill="#EAEAFB"
        />
        <path
          d="M67.8 12.744l-1.302 1.567s-1.753 2.085-3.506 4.675c-.876 1.295-1.76 2.716-2.45 4.117-.697 1.401-1.242 2.743-1.242 4.197 0 4.09 2.935 7.53 6.8 8.327V37.5h-6.8c-2.796 0-5.1 2.304-5.1 5.1 0 2.138 1.52 3.64 3.4 4.39V66.4H21.9c-4.675 0-8.5 3.825-8.5 8.5V80c0 1.986 1.235 3.56 2.869 4.828l.04.166.451.392.04.026V108.9H10v1.7c0 4.702 1.979 7.816 3.984 9.563 2 1.753 4.104 2.284 4.104 2.284l.2.053h99.025l.199-.053s2.105-.531 4.104-2.285c2.005-1.746 3.984-4.86 3.984-9.562v-1.7h-6.8V85.412l.046-.026.22-.346c1.766-1.301 3.134-2.942 3.134-5.04v-5.1c0-4.675-3.825-8.5-8.5-8.5H78V46.99c1.88-.75 3.4-2.252 3.4-4.39 0-2.796-2.304-5.1-5.1-5.1h-6.8v-1.873c3.865-.797 6.8-4.236 6.8-8.327 0-1.454-.545-2.796-1.242-4.197-.69-1.401-1.574-2.822-2.45-4.117a63.138 63.138 0 00-3.506-4.675L67.8 12.744zm0 5.485c.63.803.996 1.202 1.992 2.67.824 1.208 1.64 2.53 2.225 3.712.578 1.175.883 2.264.883 2.689a5.042 5.042 0 01-3.4 4.788V27.3a1.705 1.705 0 00-1.727-1.727c-.936.02-1.686.79-1.673 1.727v4.788a5.042 5.042 0 01-3.4-4.788c0-.425.305-1.514.883-2.69.585-1.181 1.401-2.503 2.225-3.712.996-1.467 1.361-1.866 1.992-2.67zM59.3 40.9h8.214c.186.033.372.033.552 0H76.3c.963 0 1.7.737 1.7 1.7s-.737 1.7-1.7 1.7h-1.7c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7v18.7H61V47.7c.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7h-1.7a1.67 1.67 0 01-1.7-1.7c0-.963.737-1.7 1.7-1.7zm8.5 3.4c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zM21.9 69.8h91.8c2.836 0 5.1 2.264 5.1 5.1V80c0 .87-.724 1.979-2.543 3.008l-.857.492v25.4c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7h6.461c-.398 2.55-1.348 4.316-2.477 5.313-1.354 1.182-2.53 1.467-2.61 1.487H18.826c-.08-.02-1.255-.305-2.61-1.487-1.128-.997-2.078-2.763-2.476-5.313H20.2c.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7V83.5l-.857-.492C17.523 81.978 16.8 80.87 16.8 80v-5.1c0-2.836 2.264-5.1 5.1-5.1zm71.234 8.507l-.22.14-.258-.02-.359.404-.458.292-.153.419-.033.033v.06l-.026.046-.027.166.027.107-.02.212.02.173.199.318.192.658.3.12.125.192.485.04.511.192.22-.14.305.027.418-.49.346-.213.113-.313.126-.139.04-.591-.014-.166-.292-.465-.153-.518-.232-.093-.14-.219-.544-.04-.498-.192zm-51.153.02l-1.208.93-.166.577-.014.166.538 1.421 1.468.418 1.215-.923.16-.577.02-.173-.545-1.414-1.468-.425zm5.273 3.884l-1.508.186-.763 1.322.61 1.4.519.293.166.06 1.507-.186.757-1.322-.61-1.394-.512-.306-.166-.053zm40.866.193l-.59.093-.16.06-1.056 1.102.252 1.5 1.355.705.591-.1.16-.06 1.049-1.102-.246-1.5-1.355-.698zm-50.243.863l-.59.126-.153.06-.997 1.156.32 1.487 1.387.631.585-.126.159-.067.996-1.148-.319-1.488-1.388-.63zm60.437.126l-1.528.113-.816 1.282.537 1.428.505.318.16.067 1.52-.113.817-1.282-.538-1.427-.505-.326-.152-.06zm-44.539.558l-1.48.372-.585 1.408.783 1.308.552.232.132.027.12.027h.033l1.448-.479.485-1.447-.877-1.249-.478-.159v-.013l-.133-.027zm27.32.113l-.173.02-1.249.87-.053 1.527 1.196.95.597.02.166-.027 1.255-.87.047-1.52-1.189-.95-.597-.02zm-56.725.63l-1.454.466-.491 1.44.856 1.263.565.192.166.027 1.447-.465.498-1.448-.856-1.255-.571-.193-.16-.026zm86.86 0l-.16.027-1.248.884-.033 1.52 1.202.943.597.014.166-.027 1.242-.883.04-1.52-1.202-.944-.604-.013zm-50.768.08l-1.414.565-.386 1.474.937 1.196.584.152.173.02 1.408-.57.391-1.475-.943-1.195-.584-.153-.166-.013zm13.813.067l-.173.02-1.302.79-.14 1.52 1.13 1.017.598.06.166-.014 1.301-.796.146-1.515-1.129-1.022-.597-.06zm-43.145.133l-.172.013-1.322.75-.192 1.508 1.095 1.062.598.073.166-.013 1.328-.744.186-1.514-1.089-1.062-.598-.073zm73.34 0l-1.395.61-.345 1.488.983 1.162.584.133.166.013 1.401-.617.345-1.481-.982-1.162-.585-.133-.172-.013zm-37.141.113l-1.382.644-.305 1.494 1.01 1.142.584.12.172.006 1.375-.65.312-1.495-1.01-1.135-.584-.12-.172-.006zM27 108.9c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7zm6.8 0c-.936 0-1.7.764-1.7 1.7 0 .936.764 1.7 1.7 1.7.936 0 1.7-.764 1.7-1.7 0-.936-.764-1.7-1.7-1.7z"
          fill="#2E2EE5"
          fillRule="nonzero"
        />
      </symbol>
    </svg>
  );
}
